export default {
  licenseRetry: { failed: 'Η επαλήθευση άδειας δεν ολοκληρώθηκε. Δοκιμάστε ξανά.', dismiss: 'Κλείσιμο' },
  locale: "el",
  landing: {
    hero: {
      title: "Επανάσταση AI στη Χρηματοοικονομική Ανάλυση",
      subtitle: "Κατανοήστε τις αγορές με AI, προβλέψτε το μέλλον",
      cta: "Ξεκινήστε",
      badge: "Πλατφόρμα Χρηματοοικονομικής AI της Τουρκίας",
    },
    about: {
      title: "Σχετικά με το Formind",
      mainTitle: "Χρηματοοικονομικός Βοηθός με AI",
      mainDescription:
        "Το Formind είναι ένας χρηματοοικονομικός βοηθός με τεχνητή νοημοσύνη που αναπτύχθηκε ειδικά για τις τουρκικές χρηματοοικονομικές αγορές. Συνδυάζει δεδομένα αγοράς σε πραγματικό χρόνο με ιστορικά δεδομένα για να παρέχει αναλύσεις, προβλέψεις, αναφορές και συγκρίσεις στον χρηματοοικονομικό και επενδυτικό κόσμο σε πραγματικό χρόνο.",
      summaryTitle: "Έξυπνη Λύση για Ιδρύματα",
      summaryDescription:
        "Το Formind είναι μια έξυπνη λύση AI που παρέχει στα ιδρύματα που δραστηριοποιούνται στον χρηματοοικονομικό και επενδυτικό τομέα ουσιαστική ερμηνεία πολύπλοκων δεδομένων, στρατηγικές γνώσεις και εύκολη πρόσβαση στις πληροφορίες.",
    },
    nav: {
      login: "Σύνδεση",
      register: "Εγγραφή",
      chat: "Συνομιλία",
    },
    chat: {
      title: "Χρηματοοικονομική Ανάλυση με AI Chat",
      description:
        "Ερωτήματα δεδομένων αγοράς σε πραγματικό χρόνο, τεχνική και θεμελιώδη ανάλυση, παρακολούθηση ειδοποιήσεων KAP. Ενισχύστε τις χρηματοοικονομικές σας αποφάσεις με σύστημα συνομιλίας AI.",
      feature1: "Δεδομένα αγοράς σε πραγματικό χρόνο",
      feature2: "Τεχνική και θεμελιώδη ανάλυση",
      feature3: "Παρακολούθηση ειδοποιήσεων KAP",
      feature4: "Συγκρίσεις τομέων",
    },
    mcp: {
      title: "Model Context Protocol (MCP)",
      description:
        "Πρόσβαση σε δεδομένα χρηματιστηρίου ForInvest σε πραγματικό χρόνο και ανάλυσή τους. Ενσωματώστε τα δικά σας μοντέλα AI με MCP.",
      docs: "Τεκμηρίωση και Εργαλεία",
      card1Title: "Πρόσβαση Δεδομένων σε Πραγματικό Χρόνο",
      card1Desc: "Πρόσβαση σε πραγματικό χρόνο σε δεδομένα αγοράς",
      card2Title: "Χρηματοοικονομική Ανάλυση",
      card2Desc: "Αυτοματοποιημένη ανάλυση και αναφορά",
    },
    api: {
      title: "Πρόσβαση API με Δομή Token",
      description:
        "Δημιουργήστε τις δικές σας δομές agent, ανακτήστε χρηματοοικονομικά δεδομένα και αναπτύξτε προσαρμοσμένες εφαρμογές. Ασφαλής πρόσβαση API με έλεγχο ταυτότητας βάσει token.",
      feature1: "RESTful API",
      feature2: "Ασφάλεια βάσει token",
      feature3: "Υποστήριξη δομής agent",
      feature4: "Λεπτομερής τεκμηρίωση",
      cta: "Ξεκινήστε με API",
    },
    footer: "© 2025 ForAI. Όλα τα δικαιώματα διατηρούνται.",
  },
  common: {
    login: "Σύνδεση",
    logout: "Αποσύνδεση",
    email: "Email",
    username: "Όνομα Χρήστη",
    password: "Κωδικός",
    loading: "Φόρτωση...",
    save: "Αποθήκευση",
    cancel: "Ακύρωση",
    delete: "Διαγραφή",
    edit: "Επεξεργασία",
    create: "Δημιουργία",
    update: "Ενημέρωση",
    refresh: "Ανανέωση",
    search: "Αναζήτηση",
    filter: "Φίλτρο",
    close: "Κλείσιμο",
    confirm: "Επιβεβαίωση",
    yes: "Ναι",
    no: "Όχι",
    active: "Ενεργό",
    inactive: "Ανενεργό",
    status: "Κατάσταση",
    actions: "Ενέργειες",
    date: "Ημερομηνία",
    name: "Όνομα",
    surname: "Επώνυμο",
    role: "Ρόλος",
    send: "Αποστολή",
    expand: "Επέκταση",
    collapse: "Σύμπτυξη",
    show: "Εμφάνιση",
    hide: "Απόκρυψη",
    optional: "Προαιρετικό",
  },
  auth: {
    welcome: "Καλώς ήρθατε στο ForMind",
    brandDescription: "Πλατφόρμα χρηματοοικονομικής ανάλυσης με τεχνητή νοημοσύνη. Ενισχύστε τις επενδυτικές σας αποφάσεις με δεδομένα αγοράς σε πραγματικό χρόνο, τεχνική και θεμελιώδη ανάλυση.",
    badgeAI: "Ανάλυση με AI",
    badgeRealtime: "Δεδομένα Πραγματικού Χρόνου",
    badgeSecure: "Ασφαλής Υποδομή",
    loginTitle: "Σύνδεση",
    loginSubtitle: "Συνδεθείτε στον λογαριασμό σας για να συνεχίσετε",
    registerTitle: "Εγγραφή",
    loggingIn: "Σύνδεση...",
    registering: "Εγγραφή...",
    register: "Εγγραφή",
    firstName: "Όνομα",
    lastName: "Επώνυμο",
    usernameRequired: "Απαιτούνται όνομα χρήστη και κωδικός",
    allFieldsRequired: "Όλα τα πεδία είναι υποχρεωτικά",
    passwordsDoNotMatch: "Οι κωδικοί δεν ταιριάζουν",
    loginFailed: "Η σύνδεση απέτυχε",
    loginError: "Σφάλμα κατά τη σύνδεση",
    registerDisabled: "Η εγγραφή διαχειρίζεται μέσω ForInvest. Παρακαλώ συνδεθείτε με τον λογαριασμό σας ForInvest.",
    registerSuccess: "Επιτυχής εγγραφή! Μπορείτε τώρα να συνδεθείτε.",
    alreadyHaveAccount: "Έχετε ήδη λογαριασμό;",
    confirmPassword: "Επιβεβαίωση Κωδικού",
  },
  dashboard: {
    welcome: "Καλώς ήρθατε",
    welcomeMessage: "Συνδεθήκατε επιτυχώς στην πλατφόρμα ForMind.",
    userInfo: "Πληροφορίες Χρήστη",
    administrator: "Διαχειριστής",
    client: "Πελάτης",
    testUser: "Χρήστης Δοκιμής",
  },
  sidebar: {
    home: "Αρχική",
    aiChat: "AI Συνομιλία",
    userManagement: "Διαχείριση Χρηστών",
    benchmarks: "Benchmarks",
    profile: "Το Προφίλ μου",
    settings: "Ρυθμίσεις",
  },
  modelManagement: {
    pipelineEyebrow: "ΡΥΘΜΙΣΗ PIPELINE",
    pipelineTitle: "Αναθέσεις pipeline",
    pipelineDescription: "Επιλέξτε το μοντέλο για κάθε στάδιο. Οι προηγμένες ρυθμίσεις εμφανίζονται όταν ανοίξετε μια γραμμή και αποθηκεύονται αυτόματα.",
    assignedRoles: "ανατεθειμένοι ρόλοι",
    assignedModel: "Ανατεθειμένο μοντέλο",
    customAssignment: "Προσαρμοσμένη ανάθεση",
    defaultAssignment: "Προεπιλογή",
    jevTitle: "Επιλογέας skill JEV",
    jevHelp: "Χρήση JEV πριν από την επιλογή skill",
    jevModel: "Μοντέλο JEV",
    selectJevModel: "Επιλέξτε μοντέλο JEV",
    jevThreshold: "Κατώφλι (%)",
    unavailable: "μη διαθέσιμο",
    enabled: "Ενεργό",
    disabled: "Ανενεργό",
    send: "Αποστολή",
    autoSaveNote: "Οι αλλαγές αποθηκεύονται αυτόματα όταν αφήνετε ένα πεδίο.",
  },
  pipelineCalculator: {
    eyebrow: "ΕΚΤΙΜΗΣΗ ΚΟΣΤΟΥΣ PIPELINE",
    title: "Υπολογιστής τιμολόγησης pipeline",
    subtitle: "Υπολογίστε το κόστος των μοντέλων, τα σενάρια token και την επίδραση στα όρια πακέτων.",
    loading: "Φόρτωση τιμών μοντέλων...",
    refresh: "Ανανέωση τιμών",
    errorTitle: "Οι τιμές δεν είναι διαθέσιμες",
    retry: "Δοκιμή ξανά",
    errorDescription: "Η τιμολόγηση pipeline δεν είναι προσωρινά διαθέσιμη.",
    runsLabel: "Αριθμός εκτελέσεων",
    runsHint: "Συνολικές εκτελέσεις pipeline για το σενάριο",
    cacheIncluded: "Τα cache tokens περιλαμβάνονται στο input",
    cacheIncludedHint: "Συμβατό με τον τύπο κόστους του AgentCore",
    priceUnit: "Μονάδα τιμής",
    roleBreakdown: "ΥΠΟΛΟΓΙΣΜΟΣ ΑΝΑ ΡΟΛΟ",
    roleBreakdownTitle: "Ανάλυση κόστους pipeline",
    roleBreakdownHint: "Ανοίξτε έναν ρόλο για να αλλάξετε τις υποθέσεις",
    unavailable: "Χωρίς τιμή",
    perRun: "/ εκτέλεση",
    customAssignment: "Προσαρμοσμένη ανάθεση",
    defaultAssignment: "Προεπιλεγμένο μοντέλο",
    priceUnavailable: "Δεν βρέθηκε τιμή για αυτό το μοντέλο",
    callsLabel: "Κλήσεις / εκτέλεση",
    inputLabel: "Input tokens / κλήση",
    outputLabel: "Output tokens / κλήση",
    cachedInputLabel: "Cached input / κλήση",
    cacheWriteLabel: "Cache write / κλήση",
    roleEstimate: "Εκτιμώμενο κόστος ρόλου",
    run: "εκτέλεση",
    needsPrice: "Απαιτείται τιμή",
    estimatedTotal: "Εκτιμώμενο συνολικό κόστος",
    runs: "εκτελέσεις",
    incompleteWarning: "Οι ρόλοι χωρίς τιμή εξαιρούνται από το σύνολο.",
    perRunTotal: "Γνωστό σύνολο ανά εκτέλεση",
    knownCost: "Σύνολο ρόλων με τιμή",
    modelBreakdown: "Ανάλυση ανά μοντέλο",
    noModels: "Δεν βρέθηκε υπολογίσιμο μοντέλο.",
    packageImpact: "Επίδραση στα όρια πακέτων",
    monthly: "σενάριο",
    unlimited: "Απεριόριστο",
    disclaimer: "Πρόκειται για εκτιμήσεις σεναρίου· το πραγματικό κόστος εξαρτάται από τα tokens και τη ροή του pipeline.",
    noModel: "Δεν έχει ανατεθεί μοντέλο",
  },
  header: {
  },
  chat: {
    creditExhaustedTitle: "Η πίστωση χρήσης εξαντλήθηκε",
    limitExceededProDesc: "Η διαθέσιμη πίστωση εξαντλήθηκε. Επικοινωνήστε με την υποστήριξη για επιπλέον πίστωση χρήσης.",
    limitRenewalDate: "Ανανέωση πακέτου: {date}",
    creditExhaustedDesc: "Δεν απομένει πίστωση χρήσης. Ελέγξτε το πακέτο σας ή περιμένετε την ανανέωση των δικαιωμάτων σας.",
    settings: "Ρυθμίσεις",
    newChat: "Νέα Συνομιλία",
    history: "Ιστορικό",
    starred: "Αστέρια",
    noConversations: "Δεν υπάρχουν συνομιλίες ακόμα",
    deleteConfirm: "Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή τη συνομιλία;",
    addStar: "Προσθήκη στα Αστέρια",
    removeStar: "Αφαίρεση από τα Αστέρια",
    rename: "Μετονομασία",
    conversationName: "Όνομα Συνομιλίας",
    typeMessage: "Πληκτρολογήστε το μήνυμά σας...",
    chatModeLabel: "Λειτουργία απάντησης",
    chatModeAuto: "Αυτόματο",
    chatModeAutoDescription: "Επιλέγει γρήγορη ή προηγμένη λειτουργία ανάλογα με την ερώτηση",
    chatModeFast: "Γρήγορο",
    chatModeFastDescription: "Γρήγορες απαντήσεις για απλές ερωτήσεις μίας μετοχής",
    chatModeAdvanced: "Προηγμένο",
    chatModeAdvancedDescription: "Λύνει σύνθετες ερωτήσεις ή ερωτήσεις πολλών μετοχών",
    chatModeAutoSelected: "Αυτόματη λειτουργία",
    chatModeFastResult: "Δημιουργήθηκε σε γρήγορη λειτουργία",
    chatModeAdvancedResult: "Δημιουργήθηκε σε προηγμένη λειτουργία",
    modelSelectorLabel: "Επιλογή μοντέλου",
    adaptiveThinking: "Προσαρμοστική σκέψη",
    adaptiveThinkingDescription: "Σκέφτεται βαθύτερα για σύνθετες εργασίες",
    rag: "Βάση γνώσης (RAG)",
    ragDescription: "Συμπεριλαμβάνει τα δικά σας έγγραφα στις απαντήσεις. Τα εταιρικά έγγραφα είναι πάντα ενεργά.",
    listening: "Ακούει",
    finbotReady: "Το Finbot είναι έτοιμο",
    voiceError: "Σφάλμα φωνής",
    browserNotSupported: "Ο περιηγητής δεν υποστηρίζεται",
    finbotWaiting: "Το Finbot περιμένει",
    hello: "Γεια σας!",
    welcomeMessage:
      "Ξεκινήστε να συνομιλείτε με τον βοηθό ForMind AI. Χαίρομαι που μπορώ να σας βοηθήσω με θέματα επενδύσεων και χρηματοοικονομικών.",
    quickPrompts: "Γρήγορες Προτροπές - Γρήγορη Έναρξη",
    quickPromptsSubtitle:
      "Επιλέξτε ένα από τα παρακάτω παραδείγματα για να ξεκινήσετε αμέσως την ανάλυση",
    connectionSuccessful: "Επιτυχής Σύνδεση",
    disconnected: "Αποσυνδέθηκε",
    connectionError: "Σφάλμα Σύνδεσης",
    wsConnectionClosed: "Η σύνδεση WebSocket έκλεισε. Παρακαλώ ανανεώστε τη σελίδα.",
    wsConnectionError: "Προέκυψε σφάλμα σύνδεσης. Παρακαλώ ανανεώστε τη σελίδα.",
    toolsUsed: "εργαλεία χρησιμοποιήθηκαν",
    referencesUsed: "Αναφορές που χρησιμοποιήθηκαν",
    referenceUsed: "χρησιμοποιήθηκε",
    request: "Αίτημα",
    response: "Απάντηση",
    tokens: "tokens",
    startSpeaking: "Ξεκινήστε να μιλάτε",
    voiceHint: "Αφήστε μια σύντομη σιωπή όταν τελειώσετε να μιλάτε",
    running: "Εκτελείται",
    success: "Επιτυχία",
    failed: "Απέτυχε",
    startListening: "Ξεκινήστε την ακρόαση",
    stopListening: "Σταματήστε την ακρόαση",
    howCanIHelp: "Πώς μπορώ να σας βοηθήσω σήμερα;",
    welcome: "Καλώς ήρθατε",
    preparedQuestionsLoadError: "Δεν ήταν δυνατή η φόρτωση των έτοιμων ερωτήσεων.",
    retry: "Επανάληψη",
    preparedQuestionUnavailable: "Η επιλεγμένη έτοιμη ερώτηση δεν είναι πλέον διαθέσιμη. Η λίστα ανανεώθηκε.",
    originalPrompt: "Αρχική Προτροπή",
    proposedAnalysis: "Προτεινόμενα Βήματα Ανάλυσης",
    cancel: "Ακύρωση",
    proceed: "Συνέχεια",
    mergingResults: "Συγχώνευση αποτελεσμάτων...",
    preparingResult: "Προετοιμασία Αποτελέσματος",
    preparing: "Προετοιμασία...",
    finalAnswerPreparing: "Τα δεδομένα συγκεντρώθηκαν. Η απάντηση προετοιμάζεται...",
    listenAudio: "Ακούστε ήχο",
    downloadPDF: "Λήψη ως PDF",
    followUpQuestions: "Επόμενες ερωτήσεις",
    like: "Μου αρέσει",
    unlike: "Δεν μου αρέσει",
    feedbackPlaceholder: "Πείτε μας τι πήγε στραβά (προαιρετικό)",
    feedbackReceived: "Η ανατροφοδότησή σας ελήφθη.",
    evaluatingResponse: "Αξιολόγηση ποιότητας απάντησης...",
    responseQuality: "Ποιότητα Απάντησης",
    voiceCommandBusy:
      "Η φωνητική εντολή δεν μπορεί να επεξεργαστεί αυτή τη στιγμή, παρακαλώ περιμένετε την τρέχουσα απάντηση.",
    promptRefineError: "Προέκυψε σφάλμα κατά τη βελτίωση της προτροπής",
    connectionFailed: "Η σύνδεση απέτυχε. Παρακαλώ ανανεώστε τη σελίδα.",
    reconnecting: "Επανασύνδεση...",
    ttsError: "Η μετατροπή κειμένου σε ομιλία απέτυχε",
    improvingPrompt: "Βελτίωση προτροπής...",
    refinePromptToggle: "Βελτίωση προτροπής",
    refinePromptDescription: "Βελτιώνει την ερώτηση πριν την αποστολή. Προεπισκόπηση με Tab.",
    refinedPromptLabel: "Βελτιώθηκε · Εμφάνιση αρχικού",
    refinePromptFallback: "Η βελτίωση απέτυχε· χρησιμοποιήθηκε το αρχικό κείμενο.",
    refinePromptHint: "Βελτίωση προτροπής (Tab)",
    goodMorning: "Καλημέρα",
    goodEvening: "Καλησπέρα",
    deleteWarning: "Αυτή η συνομιλία θα διαγραφεί οριστικά.",
    conversations: "Συνομιλίες",
    disclaimer: {
      title: "Σημαντική Ειδοποίηση",
      text: "Η AI μπορεί να παράγει λανθασμένες πληροφορίες. Παρακαλούμε επαληθεύστε την ακρίβεια των πληροφοριών πριν λάβετε επενδυτικές αποφάσεις."
    },
    uploadFile: "Ανέβασμα αρχείου",
    removeFile: "Αφαίρεση αρχείου",
    fileTooLarge: "Το μέγεθος του αρχείου δεν μπορεί να υπερβαίνει τα 50MB",
    unsupportedFileType: "Μη υποστηριζόμενος τύπος αρχείου. Παρακαλώ επιλέξτε αρχεία PDF, TXT, Word (.docx) ή Excel (.xlsx, .xls)",
    fileUploadError: "Προέκυψε σφάλμα κατά το ανέβασμα του αρχείου",
    stopGeneration: "Διακοπή δημιουργίας",
    stoppedMessage: "Η απάντηση διακόπηκε",
    stoppingGeneration: "Διακοπή δημιουργίας...",
    generationStopped: "Η δημιουργία διακόπηκε",
    pleaseWait: "Παρακαλώ περιμένετε ενώ σταματάμε την τρέχουσα λειτουργία",
  },
  myDocuments: {
    title: "Τα έγγραφά μου",
    description: "Τα έγγραφα που ανεβάζετε χρησιμοποιούνται μόνο στις δικές σας συνομιλίες. Κανένας άλλος χρήστης δεν τα βλέπει.",
    supportedTypes: "TXT, Markdown και PDF",
    quota: "έγγραφα",
    upload: {
      title: "Ανέβασμα εγγράφου",
      description: "Έως {size} MB ανά αρχείο. Υποστηρίζονται TXT, Markdown και PDF.",
      choose: "Επιλογή αρχείου",
      submit: "Ανέβασμα",
      uploading: "Ανεβαίνει…",
      limitReached: "Φτάσατε το όριο των {limit} εγγράφων. Διαγράψτε ένα για να ανεβάσετε νέο.",
    },
    list: {
      title: "Τα έγγραφά σας",
      refresh: "Ανανέωση",
      loading: "Φόρτωση εγγράφων…",
      empty: "Δεν έχετε ανεβάσει έγγραφα ακόμη.",
      chunks: "{count} τμήματα",
      delete: "Διαγραφή",
      deleteLabel: "Διαγραφή του εγγράφου {name}",
      deleteConfirm: "Να διαγραφεί το \"{name}\";",
    },
    notifications: {
      uploaded: "Το \"{name}\" ανέβηκε.",
      replaced: "Το \"{name}\" ενημερώθηκε.",
      deleted: "Το \"{name}\" διαγράφηκε.",
    },
  },
  // Only the error map is translated here: the admin RAG screen is Turkish/English only.
  rag: {
    errors: {
      invalidFileType: "Μη υποστηριζόμενος τύπος αρχείου. Χρησιμοποιήστε TXT, Markdown ή PDF.",
      emptyDocument: "Δεν βρέθηκε αναγνώσιμο κείμενο στο έγγραφο.",
      fileTooLarge: "Το αρχείο υπερβαίνει το επιτρεπόμενο μέγεθος.",
      invalidKey: "Το αναγνωριστικό εγγράφου δεν είναι έγκυρο.",
      invalidMetadata: "Τα μεταδεδομένα δεν είναι έγκυρα.",
      batchLimitExceeded: "Η παρτίδα υπερβαίνει το μέγιστο μέγεθος.",
      providerNotFound: "Η εγγραφή δεν βρέθηκε.",
      providerTimeout: "Το αίτημα έληξε. Δοκιμάστε ξανά.",
      providerUnavailable: "Η υπηρεσία δεν είναι προσωρινά διαθέσιμη. Δοκιμάστε ξανά.",
      providerInvalidResponse: "Η υπηρεσία επέστρεψε μη έγκυρη απάντηση.",
      validation: "Οι τιμές που δώσατε δεν είναι έγκυρες.",
      documentLimitExceeded: "Φτάσατε το όριο εγγράφων. Διαγράψτε ένα πριν ανεβάσετε νέο.",
      generic: "Η ενέργεια απέτυχε. Δοκιμάστε ξανά.",
    },
  },
  profile: {
    profile: "Προφίλ",
    title: "Οι Πληροφορίες του Προφίλ μου",
    loadingProfile: "Φόρτωση πληροφοριών προφίλ...",
    accountInfo: "Πληροφορίες Λογαριασμού",
    registrationDate: "Ημερομηνία Εγγραφής",
    tokenUsage: "Χρήση Token",
    tokenBalance: "Υπόλοιπο Token",
    usedToday: "Χρησιμοποιήθηκε Σήμερα",
    totalUsage: "Συνολική Χρήση",
    used: "χρησιμοποιήθηκε",
    totalTokenUsage: "Μηνιαία Χρήση Token",
    monthlyTokenCost: "Μηνιαίο Κόστος Token",
    usageHistory: "Ιστορικό Χρήσης",
    loadingHistory: "Φόρτωση ιστορικού...",
    noHistory: "Δεν υπάρχει ιστορικό χρήσης ακόμα",
    date: "Ημερομηνία",
    model: "Μοντέλο",
    agent: "Agent",
    inputTokens: "Tokens Εισόδου",
    outputTokens: "Tokens Εξόδου",
    totalTokens: "Σύνολο Tokens",
    cost: "Κόστος",
    promptPreview: "Προεπισκόπηση Prompt",
    apiKey: "Κλειδί API",
    hide: "Απόκρυψη",
    show: "Εμφάνιση",
    copy: "Αντιγραφή",
    copiedToClipboard: "Αντιγράφηκε στο πρόχειρο",
    copyFailed: "Η αντιγραφή απέτυχε",
    changePassword: "Αλλαγή Κωδικού",
    currentPassword: "Τρέχων Κωδικός",
    newPassword: "Νέος Κωδικός",
    confirmPassword: "Επιβεβαίωση Νέου Κωδικού",
    changing: "Αλλαγή...",
    passwordChanged: "Ο κωδικός άλλαξε επιτυχώς",
    fillAllFields: "Παρακαλώ συμπληρώστε όλα τα πεδία σωστά",
    errorLoadingProfile: "Σφάλμα φόρτωσης πληροφοριών προφίλ",
    preferences: "Προτιμήσεις",
    language: "Γλώσσα",
    security: "Ασφάλεια",
    agentPreferences: "Προτιμήσεις Agent",
    customSystemPrompt: "Προσαρμοσμένη Προτροπή Συστήματος (Μέγιστο 1024 χαρακτήρες)",
    customPromptPlaceholder:
      "Ορίστε πώς θέλετε να συμπεριφέρεται ο AI agent (π.χ., στυλ επικοινωνίας, βάθος ανάλυσης, κλπ.)",
    preferencesSaved: "Οι προτιμήσεις αποθηκεύτηκαν επιτυχώς",
    errorSavingPreferences: "Σφάλμα αποθήκευσης προτιμήσεων",
    saving: "Αποθήκευση...",
    save: "Αποθήκευση",
    licenses: "Άδειες",
    loadingLicenses: "Φόρτωση αδειών...",
    noLicenses: "Δεν βρέθηκαν ενεργές άδειες",
    realtime: "Σε Πραγματικό Χρόνο",
    endOfDay: "Τέλος Ημέρας",
    minutesDelay: "λεπτά καθυστέρηση",
  },
  users: {
    availableCredit: "Διαθέσιμη πίστωση",
    walletBalance: "Σύνολο πορτοφολιού",
    additionalCreditHint: "Η επιπλέον πίστωση παρέχει χρήση πέρα από το πακέτο. Το αχρησιμοποίητο υπόλοιπο μεταφέρεται στις επόμενες περιόδους.",
    title: "Διαχείριση Χρηστών",
    newUser: "Νέος Χρήστης",
    bulkAdd: "Μαζική Προσθήκη",
    bulkAddTitle: "Μαζική Προσθήκη Χρηστών",
    bulkJsonFile: "Αρχείο JSON",
    bulkParsedCount: "Βρέθηκαν {count} εγγραφές",
    bulkTokenNote:
      "Όλες οι εγγραφές δημιουργούνται με ρόλο πελάτη και ημερήσιο όριο 5.000.000 tokens.",
    bulkErrorTitle: "Σφάλματα",
    bulkMissingEmail: "Λείπει email",
    bulkExpiryRequired: "Απαιτείται ημερομηνία λήξης μυστικού κλειδιού",
    bulkCreate: "Μαζική Δημιουργία",
    bulkCreating: "Μαζική Δημιουργία...",
    bulkInvalidFormat: "Το JSON πρέπει να είναι λίστα (array)",
    bulkInvalidJson: "Δεν ήταν δυνατή η ανάγνωση του αρχείου JSON",
    bulkNoUsers: "Δεν βρέθηκαν εγγραφές για μαζική προσθήκη",
    bulkSuccess: "{count} χρήστες δημιουργήθηκαν επιτυχώς",
    bulkPartial: "{created} χρήστες δημιουργήθηκαν, {failed} απέτυχαν",
    bulkAllFailed: "Δεν ήταν δυνατή η δημιουργία χρηστών",
    bulkError: "Σφάλμα δημιουργίας χρηστών σε μαζική προσθήκη",
    tokenBalance: "Υπόλοιπο Token",
    dailyTokenUsage: "Χρησιμοποιήθηκε Σήμερα",
    totalTokenUsage: "Συνολική Χρήση",
    createUser: "Δημιουργία Νέου Χρήστη",
    editUser: "Επεξεργασία Χρήστη",
    changeUserPassword: "Αλλαγή Κωδικού Χρήστη",
    user: "Χρήστης",
    regenerateKeys: "Αναγέννηση Κλειδιών",
    regenerateConfirm: "Είστε σίγουροι ότι θέλετε να αναγεννήσετε τα κλειδιά API για τον χρήστη;",
    deleteConfirm: "Είστε σίγουροι ότι θέλετε να διαγράψετε τον χρήστη;",
    creating: "Δημιουργία...",
    updating: "Ενημέρωση...",
    userCreated: "Ο χρήστης δημιουργήθηκε επιτυχώς",
    userUpdated: "Ο χρήστης ενημερώθηκε επιτυχώς",
    userDeleted: "Ο χρήστης διαγράφηκε επιτυχώς",
    keysRegenerated: "Τα κλειδιά API αναγεννήθηκαν επιτυχώς",
    newApiKey: "Νέο Κλειδί API",
    keyWarning:
      "Αυτό το κλειδί εμφανίζεται μόνο μία φορά. Παρακαλώ αποθηκεύστε το σε ασφαλές μέρος.",
    passwordsNotMatch: "Οι νέοι κωδικοί δεν ταιριάζουν",
    passwordTooShort: "Ο νέος κωδικός πρέπει να έχει τουλάχιστον 6 χαρακτήρες",
    passwordChangedSuccess: "Ο κωδικός του χρήστη άλλαξε επιτυχώς",
    administrator: "Διαχειριστής",
    customer: "Πελάτης",
    test: "Δοκιμή",
    enterNewPassword: "Εισάγετε νέο κωδικό",
    reenterNewPassword: "Επανεισάγετε νέο κωδικό",
    errorLoadingUsers: "Σφάλμα φόρτωσης χρηστών",
    errorCreatingUser: "Σφάλμα δημιουργίας χρήστη",
    errorUpdatingUser: "Σφάλμα ενημέρωσης χρήστη",
    creditBalanceChanged: "Το υπόλοιπο άλλαξε. Ανοίξτε ξανά τον χρήστη από την ενημερωμένη λίστα και ελέγξτε το τρέχον υπόλοιπο πριν αποθηκεύσετε.",
    errorDeletingUser: "Σφάλμα διαγραφής χρήστη",
    errorRegeneratingKeys: "Σφάλμα αναγέννησης κλειδιών",
    errorChangingPassword: "Σφάλμα αλλαγής κωδικού",
    viewChats: "Προβολή Συνομιλιών",
    chatConversations: "Συνομιλίες Chat",
    loadingChats: "Φόρτωση συνομιλιών...",
    noChatsFound: "Δεν βρέθηκαν συνομιλίες για αυτόν τον χρήστη",
    untitledChat: "Συνομιλία χωρίς τίτλο",
    messages: "μηνύματα",
    assistant: "Βοηθός",
    errorLoadingChats: "Σφάλμα φόρτωσης συνομιλιών",
    toolsUsed: "Εργαλεία που Χρησιμοποιήθηκαν",
    viewDetails: "Προβολή Λεπτομερειών",
    request: "Αίτημα",
    response: "Απάντηση",
    addTokens: "Προσθήκη Tokens",
    currentBalance: "Τρέχον Υπόλοιπο",
    tokenAmount: "Ποσότητα Token",
    enterTokenAmount: "Εισάγετε ποσότητα token",
    description: "Περιγραφή",
    tokenDescription: "Π.χ: Προωθητική πίστωση, πληρωμή, κλπ.",
    newBalance: "Νέο Υπόλοιπο",
    adding: "Προσθήκη...",
    invalidTokenAmount: "Παρακαλώ εισάγετε έγκυρη ποσότητα token",
    errorAddingTokens: "Σφάλμα προσθήκης tokens",
  },
  settings: {
    title: "Ρυθμίσεις",
    tokenPricing: "Τιμολόγηση Token",
    tokenPricePerUnit: "Τιμή Token ανά Μονάδα",
    currentPrice: "Τρέχουσα Τιμή",
    newPrice: "Νέα Τιμή",
    save: "Αποθήκευση",
    saving: "Αποθήκευση...",
    success: "Οι ρυθμίσεις ενημερώθηκαν επιτυχώς",
    error: "Σφάλμα ενημέρωσης ρυθμίσεων",
    invalidPrice: "Παρακαλώ εισάγετε έγκυρη τιμή",
  },
  benchmark: {
    title: "Διαχείριση Benchmark",
    subtitle: "Ανεβάστε αρχεία Excel για προβολή και επεξεργασία αποτελεσμάτων.",
    new: "Νέο Benchmark",
    newHint: "Ανεβάστε το Excel και εντοπίστε αυτόματα τις στήλες μοντέλων.",
    nameLabel: "Όνομα Benchmark",
    namePlaceholder: "π.χ. Σύγκριση Μοντέλων Q4 2024",
    fileLabel: "Αρχείο Excel",
    upload: "Ανέβασμα",
    uploading: "Ανέβασμα...",
    empty: "Δεν υπάρχουν benchmarks.",
    detailTitle: "Λεπτομέρειες Benchmark",
    detailSubtitle: "Επεξεργαστείτε σειρές και δείτε HTML απαντήσεις.",
    columns: {
      name: "Όνομα Benchmark",
      uploadDate: "Ημερομηνία Ανέβασματος",
      avgScore: "Μέσο Score",
      accuracy: "Σωστά/Σύνολο",
      soru: "Ερώτηση",
      kategori: "Κατηγορία",
      referansCevap: "Απάντηση Αναφοράς",
      referansTarihi: "Ημερομηνία Αναφοράς",
      ajanCevabi: "Απάντηση Agent",
      score: "Score",
      reason: "Reason",
      dogruluk: "Ακρίβεια",
      sure: "Διάρκεια (sec)",
      actions: "Ενέργειες",
    },
    actions: {
      open: "Άνοιγμα",
      addRow: "+ Νέα Σειρά",
      addColumn: "+ Νέα Στήλη",
      preview: "Προεπισκόπηση",
      edit: "Επεξεργασία",
      save: "Αποθήκευση",
      cancel: "Ακύρωση",
      refresh: "Ανανέωση",
      delete: "Διαγραφή",
      deleteRow: "Διαγραφή σειράς",
      deleteColumn: "Διαγραφή στήλης",
      settings: "Ρυθμίσεις Στήλης",
    },
    fields: {
      columnName: "Όνομα Στήλης",
      cellColor: "Χρώμα Κελιού",
      columnPosition: "Θέση Στήλης",
      rowPosition: "Θέση Σειράς",
    },
    colors: {
      none: "Καμία",
      green: "Πράσινο",
      red: "Κόκκινο",
    },
    positions: {
      end: "Προσθήκη στο τέλος",
      top: "Προσθήκη στην αρχή",
      afterRow: "Μετά: {label}",
      afterColumn: "Μετά: {label}",
    },
    messages: {
      uploadSuccess: "Το benchmark ανέβηκε με επιτυχία.",
      updateSuccess: "Η ενημέρωση αποθηκεύτηκε.",
      addRowSuccess: "Προστέθηκε νέα σειρά.",
      deleteSuccess: "Το benchmark διαγράφηκε.",
      deleteRowSuccess: "Η σειρά διαγράφηκε.",
      deleteColumnSuccess: "Η στήλη διαγράφηκε.",
      addColumnSuccess: "Προστέθηκε νέα στήλη.",
      updateColumnSuccess: "Η στήλη ενημερώθηκε.",
      updateColorSuccess: "Το χρώμα του κελιού ενημερώθηκε.",
      confirmDeleteRow: "Να διαγραφεί η σειρά: {label};",
      confirmDeleteColumn: "Να διαγραφεί η στήλη: {label};",
    },
    errors: {
      fetchFailed: "Δεν ήταν δυνατή η φόρτωση της λίστας benchmark.",
      uploadFailed: "Αποτυχία ανεβάσματος benchmark.",
      missingUpload: "Απαιτείται όνομα benchmark και αρχείο.",
      fetchDetailFailed: "Δεν ήταν δυνατή η φόρτωση των λεπτομερειών benchmark.",
      updateFailed: "Αποτυχία ενημέρωσης σειράς.",
      addRowFailed: "Αποτυχία προσθήκης σειράς.",
      deleteFailed: "Αποτυχία διαγραφής benchmark.",
      deleteRowFailed: "Αποτυχία διαγραφής σειράς.",
      deleteColumnFailed: "Αποτυχία διαγραφής στήλης.",
      addColumnFailed: "Αποτυχία προσθήκης στήλης.",
      updateColumnFailed: "Αποτυχία ενημέρωσης στήλης.",
      updateColorFailed: "Αποτυχία ενημέρωσης χρώματος κελιού.",
    },
  },
  tour: {
    startTour: "Ξεκινήστε την Ξενάγηση",
    next: "Επόμενο",
    previous: "Προηγούμενο",
    done: "Τέλος",
    close: "Κλείσιμο",
    chat: {
      newConversation: {
        title: "Νέα Συνομιλία",
        description:
          "Κάντε κλικ σε αυτό το κουμπί για να ξεκινήσετε μια νέα συνομιλία. Κάθε νέα συνομιλία ανοίγει μια νέα σελίδα.",
      },
      history: {
        title: "Ιστορικό Συνομιλιών",
        description:
          "Αποκτήστε πρόσβαση στις προηγούμενες συνομιλίες σας εδώ. Μπορείτε να προσθέσετε αστέρι, να μετονομάσετε ή να διαγράψετε τις συνομιλίες σας.",
      },
      profile: {
        title: "Προφίλ",
        description:
          "Κάντε κλικ σε αυτό το κουμπί για να μεταβείτε στη σελίδα του προφίλ σας. Διαχειριστείτε τις πληροφορίες του λογαριασμού σας και τις προτιμήσεις σας εδώ.",
      },
      examples: {
        title: "Παραδείγματα Ερωτήσεων",
        description:
          "Χρησιμοποιήστε έτοιμες κατηγορίες ερωτήσεων για γρήγορη εκκίνηση. Θεμελιώδης ανάλυση, τεχνική ανάλυση, αγορές και άλλα.",
      },
    },
  },
  widgets: {
    commons: {
      search: "Αναζήτηση",
      ok: "OK",
      selectSymbol: "Επιλογή Συμβόλου",
      selectField: "Επιλογή Πεδίου",
      selected: "επιλεγμένα",
      noResults: "Δεν βρέθηκαν αποτελέσματα",
      follow: "Ακολούθηση",
      unfollow: "Κατάργηση Ακολούθησης",
      all: "Όλα",
      results: "αποτελέσματα"
    },
    technicalAnalysis: {
      title: "Τεχνική Ανάλυση",
      "5YM": "5 Χρόνια (Μηνιαίο)",
      "1YW": "1 Χρόνος (Εβδομαδιαίο)",
      "6M5D": "6 Μήνες (5 Ημέρες)",
      "1MD": "1 Μήνας (Ημερήσιο)",
      "1D5": "1 Ημέρα (5 Λεπτά)",
      "1H1": "1 Ώρα (1 Λεπτό)"
    },
    depth: {
      title: "Βάθος",
      viewDepthTransaction: "Βάθος + Συναλλαγές",
      viewDepth: "Βάθος",
      viewTransaction: "Συναλλαγές",
      bid: "Προσφορά",
      ask: "Ζήτηση",
      last: "Τελευταίο",
      dailyWeightedAverage: "Ημερήσιος Σταθμικός Μέσος Όρος",
      dailyChangePercentage: "Ημερήσια Μεταβολή %",
      time: "Χρόνος",
      order: "Εντολή",
      quantity: "Ποσότητα",
      total: "Σύνολο"
    },
    transactions: {
      time: "Χρόνος",
      price: "Τιμή",
      amount: "Ποσότητα",
      dchg: "Μεταβολή %",
      turnover: "Όγκος",
      last: "Τελευταίο",
      volume: "Ποσότητα"
    },
    companyInfo: {
      title: "Πληροφορίες Εταιρείας",
      code: "Κωδικός",
      companyName: "Όνομα Εταιρείας",
      establishmentDate: "Ημερομηνία Ίδρυσης",
      ipoDate: "Ημερομηνία IPO",
      registeredCapital: "Εγγεγραμμένο Κεφάλαιο",
      fieldOfActivity: "Τομέας Δραστηριότητας",
      numberOfEmployee: "Αριθμός Εργαζομένων",
      generalManager: "Γενικός Διευθυντής",
      contact: "Επικοινωνία",
      address: "Διεύθυνση",
      phone: "Τηλέφωνο",
      fax: "Φαξ",
      website: "Ιστοσελίδα",
      boardMembers: "Μέλη Διοικητικού Συμβουλίου",
      shareholdersRates: "Μετοχική Δομή",
      shareholders: "Μέτοχοι",
      subsidiaries: "Θυγατρικές & Συμμετοχές",
      exchangePosition: "Θέση Χρηματιστηρίου"
    },
    levelAnalysis: {
      title: "Ανάλυση Επιπέδου",
      noData: "Δεν υπάρχουν διαθέσιμα δεδομένα",
      weightedAverage: "Σταθμικός Μέσος Όρος",
      totalLot: "Συνολικό Lot",
      averageBid: "Μέση Προσφορά",
      averageAsk: "Μέση Ζήτηση",
      price: "Τιμή",
      lot: "Lot",
      percent: "Ποσοστό",
      percentBid: "Προσφορά %",
      percentAsk: "Ζήτηση %"
    },
    advancedGrid: {
      title: "Προηγμένος Πίνακας",
      tableView: "Πίνακας",
      gridView: "Πλέγμα",
      search: "Αναζήτηση συμβόλου...",
      noData: "Δεν υπάρχουν διαθέσιμα δεδομένα",
      addSymbol: "Προσθήκη Συμβόλου",
      editFields: "Επεξεργασία Πεδίων",
      fields: {
        E: "Σύμβολο",
        l: "Τελευταία",
        C: "Μεταβολή %",
        b: "Προσφορά",
        a: "Ζήτηση",
        t: "Ώρα",
        o: "Άνοιγμα",
        h: "Υψηλό",
        lo: "Χαμηλό",
        v: "Όγκος",
        V: "Τζίρος",
        De: "Περιγραφή"
      }
    },
    heatMap: {
      title: "Χάρτης Θερμότητας",
      tableView: "Πίνακας",
      chartView: "Γράφημα",
      notFoundData: "Δεν βρέθηκαν δεδομένα",
      symbol: "Σύμβολο",
      last: "Τελευταίο",
      change: "Μεταβολή %",
      weightedAverage: "Σταθμ. Μέσος %"
    },
    symbolDetails: {
      title: "Λεπτομέρειες Συμβόλου",
      follow: "Ακολούθηση",
      unfollow: "Κατάργηση Ακολούθησης",
      dailyChange: "Ημερήσια Μεταβολή",
      weeklyChange: "Εβδομαδιαία Μεταβολή",
      monthlyChange: "Μηνιαία Μεταβολή",
      yearlyChange: "Ετήσια Μεταβολή",
      newWindow: "Νέο Παράθυρο",
      search: "Αναζήτηση",
      fields: "Πεδία",
      chart: "Μίνι Γράφημα",
      quickOrder: "Γρήγορη Εντολή"
    }
  },
  licenses: {
    LIC_BIST_INDEX_MINI_EXT: "BIST Δείκτης Mini (Εκτεταμένο)",
    LIC_VIP_L1P: "VIP Επίπεδο 1 Premium",
    LIC_BIST_L1P: "BIST Επίπεδο 1 Premium",
    LIC_VIP_L2: "VIP Επίπεδο 2",
    LIC_BIST_L2: "BIST Επίπεδο 2",
    LIC_TEKNIK_ANALIZ: "Τεχνική Ανάλυση",
    LIC_NEWS_PICNEWS: "Ειδήσεις - PicNews",
    LIC_NEWS_FRKS_INTERNAL: "Ειδήσεις - Foreks Εσωτερικό",
    LIC_TIME: "Δεδομένα Χρόνου",
    LIC_BIST_BOND_L1P: "BIST Ομόλογο Επίπεδο 1 Premium",
    LIC_VIP_L1_FREE: "VIP Επίπεδο 1 Δωρεάν",
    LIC_EXCHANGE_BIST: "Χρηματιστήριο Κωνσταντινούπολης",
    LIC_BIST_KMTP_L2: "BIST KMTP Επίπεδο 2",
    LIC_CBT: "Συμβόλαια Μελλοντικής Εκπλήρωσης",
    LIC_SPOT: "Spot Αγορά",
    LIC_CUSTODY: "Φύλαξη",
    LIC_FIDES_PARITE: "Fides Ισοτιμία",
    LIC_FIDES_LIBOR: "Fides LIBOR",
    LIC_NEWS_AA: "Ειδήσεις - Πρακτορείο Anadolu",
    LIC_FIDES_INDEX: "Fides Δείκτης",
    LIC_INTERBANK: "Διατραπεζική",
    LIC_BIST_L2P: "BIST Επίπεδο 2 Premium",
    LIC_BIST_INDEX: "BIST Δείκτης",
    LIC_BIST_DIST: "BIST Διανομή",
    LIC_FXEXPLORER: "FX Explorer",
    LIC_OPSP_L1: "Δικαιώματα Προαίρεσης Επίπεδο 1",
    LIC_OPSP_L2: "Δικαιώματα Προαίρεσης Επίπεδο 2",
    LIC_USAGBY: "Ομόλογα Θησαυροφυλακίου ΗΠΑ",
    LIC_CBOE_EDGX: "CBOE EDGX",
    LIC_CBOE_DXE: "CBOE DXE",
    LIC_CBOE_CXE: "CBOE CXE",
    LIC_BIST_BOND_CONSOLIDATED: "BIST Ομόλογο Ενοποιημένο",
    LIC_BOVESPA: "Bovespa",
    LIC_MSCI: "Δείκτες MSCI",
    LIC_PRODUCT_DESKTOP_FXPLUS: "Προϊόν - Desktop FX Plus",
    LIC_PRODUCT_WEB_FOREKSTRADER: "Προϊόν - Web ForeksTrader",
    LIC_PRODUCT_MOBILE_FOREKSTRADER: "Προϊόν - Mobile ForeksTrader",
    LIC_TEFASFUND_AND_EUROBOND: "Αμοιβαίο Κεφάλαιο TEFAS και Ευρωομόλογο",
    LIC_ATHENS_INDEX: "Δείκτες Αθηνών",
    LIC_BIST_ETP: "BIST ETP",
    LIC_VIP_BASIC: "VIP Βασικό",
    LIC_NEWS_KAP: "Ειδήσεις - KAP",
    LIC_NEWS_FRKS: "Ειδήσεις - Foreks",
    LIC_MKK: "MKK",
    LIC_NEWS_IHA: "Ειδήσεις - IHA",
    LIC_SETTLEMENT: "Διακανονισμός",
    LIC_BIST_KMTP_L1: "BIST KMTP Επίπεδο 1",
    LIC_KYD: "KYD",
    LIC_BIST_KMTP_L1P: "BIST KMTP Επίπεδο 1 Premium",
    LIC_BIST_EXT: "BIST Εκτεταμένο",
    LIC_VIP_EXT: "VIP Εκτεταμένο",
    LIC_BOND_EXT: "Ομόλογο Εκτεταμένο",
    LIC_CALENDAR: "Ημερολόγιο",
    LIC_DJ_INDEX: "Δείκτες Dow Jones",
    LIC_VIP_L2P: "VIP Επίπεδο 2 Premium",
    LIC_PING_PONG: "Ping Pong",
    LIC_VIP_DIST: "VIP Διανομή",
    LIC_FTSE_INDEX: "Δείκτες FTSE",
    LIC_SP_INDEX: "Δείκτες S&P",
    LIC_EUX: "Eurex",
    LIC_NIKKEI_INDEX: "Δείκτες Nikkei",
    LIC_BIST_L1: "BIST Επίπεδο 1",
    LIC_SWISS_INDEX: "Δείκτες Ελβετίας",
    LIC_BIST_BOND_L1: "BIST Ομόλογο Επίπεδο 1",
    LIC_BIST_INDEX_MINI_BASE: "BIST Δείκτης Mini (Βασικό)",
    LIC_VIP_L1: "VIP Επίπεδο 1"
  },
  fields: {
    CODE: "Σύμβολο",
    TIME: "Χρόνος",
    SERIALCODE: "Κωδικός Σειράς",
    SHORTMARKETCODE: "Κωδικός Αγοράς",
    OPEN: "Άνοιγμα",
    VWAP: "VWAP",
    TRADETYPE: "Τύπος Συναλλαγής",
    BUYERCODE: "Κωδικός Αγοραστή",
    SELLERCODE: "Κωδικός Πωλητή",
    TRADENUMBER: "Trade No",
    PRICE: "Price",
    SIZE: "Last Volume",
    TRADETIME: "Trade Time",
    TRANSACTIONDIRECTION: "Transaction Direction",
    TRADEDVALUE: "Traded Value",
    BIDORASKDIRECTION: "Bid Or Ask Direction",
    LASTDIRECTION: "Last Direction",
    PREVIOUSDIRECTION: "Previous Direction",
    LAST: "Last",
    DATEEX: "DateEx",
    NETCHANGE: "Net Change",
    NETCHANGEPERCENT: "Net Change Percent",
    EVALUATIONDATE: "Evoluation Date",
    OFFICIALCLOSE: "Official Close",
    PROMPTDATE: "Prompt Date",
    PREVIOUSLAST: "Previous Last",
    VOLUME: "Volume",
    TURNOVER: "Turnover",
    DAILYCHANGE: "D.Chg",
    DAILYCHANGEPERCENT: "D.Chg %",
    WEEKLYCHANGE: "W.Chg",
    WEEKLYCHANGEPERCENT: "W.Chg %",
    MONTHLYCHANGE: "M.Chg",
    MONTHLYCHANGEPERCENT: "M.Chg %",
    YEARLYCHANGE: "Y.Chg",
    YEARLYCHANGEPERCENT: "Y.Chg %",
    DIRECTION: "Direction",
    BID: "Bid",
    ASK: "Ask",
    LOW: "Low",
    HIGH: "High",
    MIDPRICE: "Mid. Price",
    VOLATILITY: "Volatility",
    MMCODE: "MM. Code",
    MMBIDQUOTATION: "MM. Bid Quotation",
    MMASKQUOTATION: "MM. Ask Quotation",
    MMBIDQUOTATIONAMOUNT: "MM. Bid Quotation Volume",
    MMASKQUOTATIONAMOUNT: "MM. Ask Quotation Volume",
    WTDLOW: "Weekly Low",
    WTDHIGH: "Weekly High",
    PREVIOUSWEEKCLOSE: "Previous Week Close",
    MTDLOW: "Monthly Low",
    MTDHIGH: "Monthly High",
    PREVIOUSMONTHCLOSE: "Previous Month Close",
    YTDLOW: "YTD Low",
    YTDHIGH: "YTD High",
    PREVIOUSYEARCLOSE: "Previous Year Close",
    CLOSE: "Κλείσιμο",
    PREVIOUSCLOSE: "Previous Close",
    CLOSINGSESSIONPRICE: "Closing Session Price",
    LOWERLIMIT: "Lower Limit",
    UPPERLIMIT: "Upper Limit",
    TICKSIZE: "Tick Size",
    GROUP: "Group",
    BASEPRICE: "Base Price",
    TRADINGMETHOD: "Trading Method",
    STATUS: "Status",
    TOTALTURNOVER: "Total Turnover",
    TOTALVOLUME: "Συνολικός Όγκος",
    BIDRATIO: "Bid Ratio",
    ASKRATIO: "Ask Ratio",
    BIDVWAP: "Bid VWAP",
    BIDTOTALAMOUNT: "Bid Total Volume",
    ASKVWAP: "Ask VWAP",
    ASKTOTALAMOUNT: "Ask Total Volume",
    PERIODICVWAP: "Periodic VWAP",
    BIDPRICE0: "Bid Price 0",
    BIDPRICE1: "Bid Price 1",
    BIDPRICE2: "Bid Price 2",
    BIDPRICE3: "Bid Price 3",
    BIDPRICE4: "Bid Price 4",
    BIDPRICE5: "Bid Price 5",
    BIDPRICE6: "Bid Price 6",
    BIDPRICE7: "Bid Price 7",
    BIDPRICE8: "Bid Price 8",
    BIDPRICE9: "Bid Price 9",
    BIDAVERAGEPRICE: "Bid Average Price",
    BIDAMOUNT0: "Bid Volume 0",
    BIDAMOUNT1: "Bid Volume 1",
    BIDAMOUNT2: "Bid Volume 2",
    BIDAMOUNT3: "Bid Volume 3",
    BIDAMOUNT4: "Bid Volume 4",
    BIDAMOUNT5: "Bid Volume 5",
    BIDAMOUNT6: "Bid Volume 6",
    BIDAMOUNT7: "Bid Volume 7",
    BIDAMOUNT8: "Bid Volume 8",
    BIDAMOUNT9: "Bid Volume 9",
    BIDAMOUNTTOTAL: "Bid Volume Total",
    BIDQTY0: "Bid Qty 0",
    BIDQTY1: "Bid Qty 1",
    BIDQTY2: "Bid Qty 2",
    BIDQTY3: "Bid Qty 3",
    BIDQTY4: "Bid Qty 4",
    BIDQTY5: "Bid Qty 5",
    BIDQTY6: "Bid Qty 6",
    BIDQTY7: "Bid Qty 7",
    BIDQTY8: "Bid Qty 8",
    BIDQTY9: "Bid Qty 9",
    BIDQTYTOTAL: "Bid Qty Total",
    BIDTIME0: "Bid Time 0",
    BIDTIME1: "Bid Time 1",
    BIDTIME2: "Bid Time 2",
    BIDTIME3: "Bid Time 3",
    BIDTIME4: "Bid Time 4",
    BIDTIME5: "Bid Time 5",
    BIDTIME6: "Bid Time 6",
    BIDTIME7: "Bid Time 7",
    BIDTIME8: "Bid Time 8",
    BIDTIME9: "Bid Time 9",
    ASKPRICE0: "Ask Price 0",
    ASKPRICE1: "Ask Price 1",
    ASKPRICE2: "Ask Price 2",
    ASKPRICE3: "Ask Price 3",
    ASKPRICE4: "Ask Price 4",
    ASKPRICE5: "Ask Price 5",
    ASKPRICE6: "Ask Price 6",
    ASKPRICE7: "Ask Price 7",
    ASKPRICE8: "Ask Price 8",
    ASKPRICE9: "Ask Price 9",
    ASKAVERAGEPRICE: "Ask Average Price",
    ASKAMOUNT0: "Ask Volume 0",
    ASKAMOUNT1: "Ask Volume 1",
    ASKAMOUNT2: "Ask Volume 2",
    ASKAMOUNT3: "Ask Volume 3",
    ASKAMOUNT4: "Ask Volume 4",
    ASKAMOUNT5: "Ask Volume 5",
    ASKAMOUNT6: "Ask Volume 6",
    ASKAMOUNT7: "Ask Volume 7",
    ASKAMOUNT8: "Ask Volume 8",
    ASKAMOUNT9: "Ask Volume 9",
    ASKAMOUNTTOTAL: "Ask Volume Total",
    ASKQTY0: "Ask Qty 0",
    ASKQTY1: "Ask Qty 1",
    ASKQTY2: "Ask Qty 2",
    ASKQTY3: "Ask Qty 3",
    ASKQTY4: "Ask Qty 4",
    ASKQTY5: "Ask Qty 5",
    ASKQTY6: "Ask Qty 6",
    ASKQTY7: "Ask Qty 7",
    ASKQTY8: "Ask Qty 8",
    ASKQTY9: "Ask Qty 9",
    ASKQTYTOTAL: "Ask Qty Total",
    ASKTIME0: "Ask Time 0",
    ASKTIME1: "Ask Time 1",
    ASKTIME2: "Ask Time 2",
    ASKTIME3: "Ask Time 3",
    ASKTIME4: "Ask Time 4",
    ASKTIME5: "Ask Time 5",
    ASKTIME6: "Ask Time 6",
    ASKTIME7: "Ask Time 7",
    ASKTIME8: "Ask Time 8",
    ASKTIME9: "Ask Time 9",
    CONTRACTS: "Contracts",
    WOWLOW: "WOW Low",
    WOWLOWDATE: "WOW Low Date",
    WOWHIGH: "WOW High",
    WOWHIGHDATE: "WOW High Date",
    WOWPREVIOUSCLOSE: "WOW Previous Close",
    MOMLOW: "MOM Low",
    MOMLOWDATE: "MOM Low Date",
    MOMHIGH: "MOM High",
    MOMHIGHDATE: "MOM High Date",
    MOMPREVIOUSCLOSE: "MOM Previous Close",
    YOYLOW: "YOY Low",
    YOYLOWDATE: "YOY Low Date",
    YOYHIGH: "YOY High",
    YOYHIGHDATE: "YOY High Date",
    YOYPREVIOUSCLOSE: "YOY Previous Close",
    VALOR: "Valor",
    BIDRATE: "Bid Rate",
    ASKRATE: "Ask Rate",
    LASTTRADEDATE: "Last Trade Date",
    LASTRATE: "Last Rate",
    CY: "CY",
    DTM: "DTM",
    ACCRUEDINTEREST: "Accrued Interest",
    BIDSETTLEMENTPRICE: "Bid Settlement Price",
    ASKSETTLEMENTPRICE: "Ask Settlement Price",
    LASTSETTLEMENTPRICE: "Last Settlement Price",
    DTE: "DTE",
    SIMPLERATE: "Simple Rate",
    COMPOUNDRATE: "Compound Rate",
    MMVALOR: "MM Valor",
    TYPE: "Type",
    MMQUOTATION: "MM Quotation",
    MMQUOTERATE: "MM Quote Rate",
    MMQUOTEAMOUNT: "MM Quote Volume",
    CPI: "CPI",
    PREVIOUSCLOSERATE: "Previous Close Rate",
    PREVIOUSCLOSEDATE: "Previous Close Date",
    LOWRATE: "Low Rate",
    HIGHRATE: "High Rate",
    VALOR2: "Valor 2",
    DAYS: "Days",
    VWAR: "VWAR",
    DATE: "Ημερομηνία",
    WTDLOWDATE: "WTD Low Date",
    WTDHIGHDATE: "WTD High Date",
    MTDLOWDATE: "MTD Low Date",
    MTDHIGHDATE: "MTD High Date",
    YTDLOWDATE: "YTD Low Date",
    YTDHIGHDATE: "YTD High Date",
    EXPIREDATE: "Expire Date",
    CONTINOUSCODE: "Continous Code",
    INSTRUMENT: "Instrument",
    BOARD: "Board",
    SESSION: "Session",
    PREVIOUSSETTLEMENTPRICE: "Previous Settlement Price",
    SETTLEMENTPRICE: "Settlement Price",
    TOTALPREMIUM: "Total Premium",
    OPENINTEREST: "Open Interest",
    OPENINTERESTCHANGE: "Open Interest Change",
    UNDERLYINGSECURITY: "Underlying Security",
    OPTIONTYPE: "Option Type",
    OPTIONCLASS: "Option Class",
    STRIKEPRICE: "Strike Price",
    SECURITYGROUP: "Security Group",
    SECURITYGROUPNO: "Security Group No",
    LISTINGDATE: "Listing Date",
    CONTRACTMULTIPLIER: "Contract Multiplier",
    SETTLEMENTTYPE: "Settlement Type",
    PARENTCONTRACT: "Parent Contract",
    ACTIONTYPE: "Action Type",
    MARGINPERCENTAGE: "Margin Percentage",
    TRADINGUNITCOLLATERAL: "Trading Unit Collateral",
    CONTINOUSCODE2: "Continuous Code 2",
    FOREKSUNDERLYINGSECURITY: "Foreks UnderlyingSecurity",
    SECURITYCOUNT: "Security Count",
    SHORTNAME: "Short Name",
    SHORTNAMEENGLISH: "Short Name English",
    TRADECONDITION: "Trade Condition",
    SOURCE: "Source",
    STOCKS: "Stocks",
    TITLE: "Title",
    BIDTRADETOTALVOLUME: "Bid Trade Total Volume",
    ASKTRADETOTALVOLUME: "Ask Trade Total Volume",
    BIDTRADETOTALTURNOVER: "Bid Trade Total Turnover",
    ASKTRADETOTALTURNOVER: "Ask Trade Total Turnover",
    PRICESTEP: "Price Step",
    EQUILIBRIUMPRICE: "Equilibrium Price",
    EQUILIBRIUMVOLUME: "Equilibrium Volume",
    EPBIDAMOUNT: "EP Bid Volume",
    EPASKAMOUNT: "EP Ask Volume",
    CAPITAL: "Capital",
    PUBLICOFFERINGRATIO: "Public Offering Ratio",
    INDICES: "Indices",
    NETCAPITAL: "Net Capital",
    NETPROFIT: "Net Profit",
    LASTPERIOD: "Last Period",
    NOMINAL: "Nominal",
    ISIN: "ISIN",
    NETDIVIDEND: "Net Dividend",
    FREEFLOATRATE: "Free Float Rate",
    LASTPERIODPROFIT: "Last Period Profit",
    INDEXWEIGHT: "Index Weight",
    INDEXFFR: "Index FFR",
    ISSUER: "Issuer",
    GROSSSETTLEMENT: "Gross Settlement",
    MARKETVALUE: "Market Value",
    PRICEEARNING: "Price Earning",
    PUBLICSTOCKSIZE: "Public Stock Size",
    FREEFLOATSTOCKSIZE: "Free Float Stock Size",
    FREEFLOATMARKETVALUE: "Free Float Market Value",
    EARNIGPERSHARE: "Earning Per Share",
    DIVIDENDYIELD: "Dividend Yield",
    PRICEBOOKVALUE: "Price Book Value",
    BOOKVALUE: "Book Value",
    PLASMAN: "Plasman",
    PAYOUTRATIO: "Payout Ratio",
    SPREAD: "Spread",
    COUPONRATE: "Coupon Rate",
    PRICINGSOURCE: "Pricing Source",
    PRICINGSOURCENAME: "Pricing Source Name",
    BESTBIDTIME: "Best Bid Time",
    BESTASKTIME: "Best Ask Time",
    DELTA: "Delta",
    THETA: "Theta",
    GAMMA: "Gamma",
    VEGA: "Vega",
    RHO: "Rho",
    BARRIER: "Barrier",
    BSPRICE: "BS Price",
    BSDIFF: "BS Diff",
    BSCHANGEPERCENT: "BS Change Percent",
    SETTLEMENTCHANGE: "Settlement Change",
    SETTLEMENTCHANGEPERCENT: "Settlement Change Percent",
    XU030WEIGHT: "XU030 Weight",
    XU050WEIGHT: "XU050 Weight",
    XU100WEIGHT: "XU100 Weight",
    XUTUMWEIGHT: "XUTUM Weight",
    THEOPRICE21: "Theo Price 21",
    THEOPRICE42: "Theo Price 42",
    THEOPRICE63: "Theo Price 63",
    THEOPRICE126: "Theo Price 126",
    THEOPRICE252: "Theo Price 252",
    THEOPRICE: "Theo Price",
    THEOPRICECHANGE: "Theo Price Change",
    THEOPRICECHANGEPERCENT: "Theo Price Change Percent",
    HISVOL21: "His Vol 21",
    HISVOL42: "His Vol 42",
    HISVOL63: "His Vol 63",
    HISVOL126: "His Vol 126",
    HISVOL252: "His Vol 252",
    HISVOL30: "His Vol 30",
    TOTALCAPITAL: "Total Capital",
    LIQUIDASSETS: "Liquid Assets",
    PORTFOLIO: "Portfolio",
    EMM: "EMM",
    ASSET: "Asset",
    NUMOFSHARES: "Number Of Shares",
    OUTSTANDINGSHARES: "Outstanding Shares",
    PARTNERCOUNT: "Partner Count",
    BILLSPERCENTAGE: "Bills Percentage",
    BONDSPERCENTAGE: "Bonds Percentage",
    REVERSEREPOPERCENTAGE: "Reverse Repo Percentage",
    EQUITYPERCENTAGE: "Equity Percentage",
    PRIVATEDEBTSPERCENTAGE: "Private Debts Percentage",
    FOREIGNSECPERCENTAGE: "Foreign Sec Percentage",
    OTHERPERCENTAGE: "Other Percentage",
    NPDEBTPERCENTAGE: "NP Debt Percentage",
    EMMPERCENTAGE: "EMM Percentage",
    DAY91: "Day 91",
    DAY182: "Day 182",
    DAY273: "Day 273",
    DAY365: "Day 365",
    DAY456: "Day 456",
    DAYGEN: "Day Gen",
    OVERNIGHTEQUAL: "Over Night Equal",
    FUNDTYPE: "Fund Type",
    SIMPLELEVERAGE: "Simple Leverage",
    ACTIVELEVERAGE: "Active Leverage",
    SPOTPRICE: "Spot Price",
    SPOTPRICECHANGE: "Spot Price Change",
    SPOTPRICECHANGEPERCENT: "SpotPrice Change Percent",
    HIGHCHANGEPERCENT: "High Change Percent",
    LOWCHANGEPERCENT: "Low Change Percent",
    OPENCHANGEPERCENT: "Open Change Percent",
    FLUCTUATION: "Fluctuation",
    VWAPCHANGE: "VWAP Change",
    VWAPCHANGEPERCENT: "VWAP Change Percent",
    DIFFTOTALTURNOVER: "Diff Total Turnover",
    DIFFTOTALTURNOVERPERCENT: "Diff Total Turnover Percent",
    WARRANTRATE: "Warrant Rate",
    OPTIONSTATUS: "Option Status",
    NAME: "Name",
    DESCRIPTION: "Description",
    TICKER: "Ticker",
    MARKETSECTOR: "Market Sector",
    SECURITYTYPE: "Security Type",
    CURRENCY: "Currency",
    EXCHANGE: "Exchange",
    PRECISION: "Precision",
    EXERCISETYPE: "Exercise Type",
    BIDAMOUNT: "Bid Volume",
    ASKAMOUNT: "Ask Volume",
    DAILYDIRECTION: "Daily Direction",
    WOWEEKLYCHANGE: "WO Weekly Change",
    WOWEEKLYCHANGEPERCENT: "WO Weekly Change Percent",
    MOMONTHLYCHANGE: "MO Monthly Change",
    MOMONTHLYCHANGEPERCENT: "MO Monthly Change Percent",
    YOYEARLYCHANGE: "YO YearlyChange",
    YOYEARLYCHANGEPERCENT: "YO Yearly Change Percent",
    WTDVOLUME: "WTD Volume",
    WTDTURNOVER: "WTD Turnover",
    MTDVOLUME: "MTD Volume",
    MTDTURNOVER: "MTD Turnover",
    YTDVOLUME: "YTD Volume",
    YTDTURNOVER: "YTD Turnover",
    WOWVOLUME: "WOW Volume",
    WOWTURNOVER: "WOW Turnover",
    MOMVOLUME: "MOM Volume",
    MOMTURNOVER: "MOM Turnover",
    YOYVOLUME: "YOY Volume",
    YOYTURNOVER: "YOY Turnover",
    WEEKLYAVERAGEVOLUME: "Weekly Average Volume",
    WEEKLYAVERAGETURNOVER: "Weekly Average Turnover",
    WEEKLYAVERAGEVOLUME2: "Weekly Average Volume 2",
    WEEKLYAVERAGETURNOVER2: "Weekly Average Turnover 2",
    MONTHLYAVERAGEVOLUME: "Monthly Average Volume",
    MONTHLYAVERAGETURNOVER: "Monthly Average Turnover",
    MONTHLYAVERAGEVOLUME2: "Monthly Average Volume 2",
    MONTHLYAVERAGETURNOVER2: "Monthly Average Turnover 2",
    YEARLYAVERAGEVOLUME: "Yearly Average Volume",
    YEARLYAVERAGETURNOVER: "Yearly Average Turnover",
    YEARLYAVERAGEVOLUME2: "Yearly Average Volume 2",
    YEARLYAVERAGETURNOVER2: "Yearly Average Turnover 2",
    WAITINGBIDAMOUNT0: "Waiting Bid Volume 0",
    WAITINGBIDAMOUNT1: "Waiting Bid Volume 1",
    WAITINGBIDAMOUNT2: "Waiting Bid Volume 2",
    WAITINGBIDAMOUNT3: "Waiting Bid Volume 3",
    WAITINGBIDAMOUNT4: "Waiting Bid Volume 4",
    WAITINGBIDAMOUNT5: "Waiting Bid Volume 5",
    WAITINGBIDAMOUNT6: "Waiting Bid Volume 6",
    WAITINGBIDAMOUNT7: "Waiting Bid Volume 7",
    WAITINGBIDAMOUNT8: "Waiting Bid Volume 8",
    WAITINGBIDAMOUNT9: "Waiting Bid Volume 9",
    WAITINGASKAMOUNT0: "Waiting Ask Volume 0",
    WAITINGASKAMOUNT1: "Waiting Ask Volume 1",
    WAITINGASKAMOUNT2: "Waiting Ask Volume 2",
    WAITINGASKAMOUNT3: "Waiting Ask Volume 3",
    WAITINGASKAMOUNT4: "Waiting Ask Volume 4",
    WAITINGASKAMOUNT5: "Waiting Ask Volume 5",
    WAITINGASKAMOUNT6: "Waiting Ask Volume 6",
    WAITINGASKAMOUNT7: "Waiting Ask Volume 7",
    WAITINGASKAMOUNT8: "Waiting Ask Volume 8",
    WAITINGASKAMOUNT9: "Waiting Ask Volume 9",
    WAITINGBIDTURNOVER0: "Waiting Bid Turnover 0",
    WAITINGBIDTURNOVER1: "Waiting Bid Turnover 1",
    WAITINGBIDTURNOVER2: "Waiting Bid Turnover 2",
    WAITINGBIDTURNOVER3: "Waiting Bid Turnover 3",
    WAITINGBIDTURNOVER4: "Waiting Bid Turnover 4",
    WAITINGBIDTURNOVER5: "Waiting Bid Turnover 5",
    WAITINGBIDTURNOVER6: "Waiting Bid Turnover 6",
    WAITINGBIDTURNOVER7: "Waiting Bid Turnover 7",
    WAITINGBIDTURNOVER8: "Waiting Bid Turnover 8",
    WAITINGBIDTURNOVER9: "Waiting Bid Turnover 9",
    WAITINGASKTURNOVER0: "Waiting Ask Turnover 0",
    WAITINGASKTURNOVER1: "Waiting Ask Turnover 1",
    WAITINGASKTURNOVER2: "Waiting Ask Turnover 2",
    WAITINGASKTURNOVER3: "Waiting Ask Turnover 3",
    WAITINGASKTURNOVER4: "Waiting Ask Turnover 4",
    WAITINGASKTURNOVER5: "Waiting Ask Turnover 5",
    WAITINGASKTURNOVER6: "Waiting Ask Turnover 6",
    WAITINGASKTURNOVER7: "Waiting Ask Turnover 7",
    WAITINGASKTURNOVER8: "Waiting Ask Turnover 8",
    WAITINGASKTURNOVER9: "Waiting Ask Turnover 9",
    MARKETVALUEUSD: "Market Value USD",
    MARKETVALUEEUR: "Market Value EUR",
    LEVELCHANGE: "Level Change",
    SESSIONSTARTTIME: "Session Start Time",
    SESSIONENDTIME: "Session End Time",
    SESSIONDATE: "Session Date",
    PREVIOUSSESSIONDATE: "Previous Session Date",
    OPENFLAG: "Open Flag",
    RISKLEVEL: "Risk Level",
    GMT: "GMT",
    MATURITY: "Maturity",
    SMA5: "SMA5",
    SMA10: "SMA10",
    SMA20: "SMA20",
    SMA50: "SMA50",
    SMA100: "SMA100",
    SMA200: "SMA200",
    EMA5: "EMA5",
    EMA10: "EMA10",
    EMA20: "EMA20",
    EMA50: "EMA50",
    EMA100: "EMA100",
    EMA200: "EMA200",
    RSI14: "RSI14",
    MACD122609: "MACD122609",
    BOLUP2002: "BOLUP2002",
    BOLDOWN2002: "BOLDOWN2002",
    ADX14: "ADX14",
    DABTC: "DABTC",
    DASTC: "DASTC",
    DABTQ: "DABTQ",
    DASTQ: "DASTQ",
    DABSCR: "DABSCR",
    DABSQR: "DABSQR",
    DATBSCR: "DATBSCR",
    DATBSQR: "DATBSQR",
    DAWT: "DAWT",
    DAWAT: "DAWAT",
    DAWBT: "DAWBT",
    DAWST: "DAWST",
    DAOC: "DAOC",
    DATOC: "DATOC",
    DAOQ: "DAOQ",
    DATOQ: "DATOQ",
    DABOC: "DABOC",
    DASOC: "DASOC",
    DABOQ: "DABOQ",
    DASOQ: "DASOQ",
    DAFAKC: "DAFAKC",
    DAABQ: "DAABQ",
    DAASQ: "DAASQ",
    DAVBQ: "DAVBQ",
    DAVSQ: "DAVSQ",
    DACXC: "DACXC",
    DACXQ: "DACXQ",
    DACXBC: "DACXBC",
    DACXSC: "DACXSC",
    DACXBQ: "DACXBQ",
    DACXSQ: "DACXSQ",
    DATCXC: "DATCXC",
    DAWCX: "DAWCX",
    DAWCXB: "DAWCXB",
    DAWCXS: "DAWCXS",
    DACXCR: "DACXCR",
    DACXQR: "DACXQR",
    DATCXCR: "DATCXCR",
    DATCXQR: "DATCXQR",
    M1: "M1",
    M3: "M3",
    M6: "M6",
    M12: "M12",
    OPTIONPREMIUMTURNOVER: "Option Premium Turnover",
    LOCALE: "Locale",
    TAG: "Tag",
    NEWSID: "News Id",
    CONTENT: "Content",
    HEADER: "Header",
    SUMMARY: "Summary",
    TOPFIVEBROKERBIDTRADEVOLUME: "Top Five Broker Bid Trade Volume",
    TOPFIVEBROKERASKTRADEVOLUME: "Top Five Broker Ask Trade Volume",
    TOPFIVEBROKERNETTRADEVOLUME: "Top Five Broker Net Trade Volume",
    SNAPSHOT: "Snapshot",
    REALTRADENUMBER: "Real TradeNumber",
    TRADEID: "TradeId",
    FIXINGSETTLEMENTPRICE: "Fixing Settlement Price",
    PREVIOUSSETTLEMENTPRICECLOSE: "Previous Settlement Price Close",
    STATE: "State",
    TRADEOPERATION: "Trade Operation",
    ALPHA200: "Alpha 200",
    BETA200: "Beta 200",
    EQUILIBRIUMCHANGEPERCENT: "Equilibrium Change Percent",
    DIFFTOTALVOLUME: "Diff Total Volume",
    AVERAGERATE: "Average Rate",
    DATETIME: "Date Time",
    ESTIMATEDBIDPRICE: "Estimated Bid Price",
    ESTIMATEDASKPRICE: "Estimated Ask Price",
    BIDRATE0: "Bid Rate 0",
    BIDRATE1: "Bid Rate 1",
    BIDRATE2: "Bid Rate 2",
    BIDRATE3: "Bid Rate 3",
    BIDRATE4: "Bid Rate 4",
    BIDRATE5: "Bid Rate 5",
    BIDRATE6: "Bid Rate 6",
    BIDRATE7: "Bid Rate 7",
    BIDRATE8: "Bid Rate 8",
    BIDRATE9: "Bid Rate 9",
    ASKRATE0: "Ask Rate 0",
    ASKRATE1: "Ask Rate 1",
    ASKRATE2: "Ask Rate 2",
    ASKRATE3: "Ask Rate 3",
    ASKRATE4: "Ask Rate 4",
    ASKRATE5: "Ask Rate 5",
    ASKRATE6: "Ask Rate 6",
    ASKRATE7: "Ask Rate 7",
    ASKRATE8: "Ask Rate 8",
    ASKRATE9: "Ask Rate 9",
    NOMINALOPTIONPREMIUMTURNOVER: "Nominal Option Premium Turnover",
    TIMEMS: "Time Ms",
    MMQUOTETIME: "MM Quote Time",
    MMQUOTETYPE: "MM Quote Type",
    DEPTHTIME: "Depth Time",
    BIDQTY: "Bid Qty",
    ASKQTY: "Ask Qty",
    RATE: "Rate",
    OPENRATE: "Open Rate",
    MMQUOTEBROKER: "MM Quote Broker",
    MBOORDERKEY: "MBO Order Key",
    MBOBUYORSELL: "MBO Buy Or Sell",
    MBOORDERCLASS: "MBO Order Class",
    MBOPRICE: "MBO Price",
    MBOVOLUME: "MBO Volume",
    ADDITIONALREFERENCEPRICE: "Additional Reference Price",
    ACCUMULATEDTRADEREPORTVOLUME: "Accumulated TradeReport Volume",
    TOTALTURNOVERCURRENCY: "Total Turnover Currency",
    ACCUMULATEDTRADEREPORTTURNOVER: "Accumulated Trade Report Turnover",
    ACCUMULATEDTRADEREPORTTURNOVERCURRENCY: "Accumulated Trade Report Turnover Currency",
    TURNOVERCURRENCY: "Turnover Currency",
    TOPFIVEBROKERBIDTRADETURNOVER: "Top Five Broker Bid Trade Turnover",
    TOPFIVEBROKERASKTRADETURNOVER: "Top Five Broker Ask Trade Turnover",
    TOPFIVEBROKERNETTRADETURNOVER: "Top Five Broker Net Trade Turnover",
    TOPTENBROKERBIDTRADEVOLUME: "Top Ten Broker Bid Trade Volume",
    TOPTENBROKERASKTRADEVOLUME: "Top Ten Broker Ask Trade Volume",
    TOPTENBROKERNETTRADEVOLUME: "Top Ten Broker Net Trade Volume",
    TOPTENBROKERBIDTRADETURNOVER: "Top Ten Broker Bid Trade Turnover",
    TOPTENBROKERASKTRADETURNOVER: "Top Ten Broker Ask Trade Turnover",
    TOPTENBROKERNETTRADETURNOVER: "Top Ten Broker Net Trade Turnover",
    VWAPRATE: "VWAP Rate",
    VWAPSETTLEMENT: "VWAP Settlement",
    VWAPCOMPOUNDRATE: "VWAP Compound Rate",
    ATTACHMENTS: "Attachments",
    BIDCOLLATERALPRICE0: "Bid Collateral Price 0",
    BIDCOLLATERALPRICE1: "Bid Collateral Price 1",
    BIDCOLLATERALPRICE2: "Bid Collateral Price 2",
    BIDCOLLATERALPRICE3: "Bid Collateral Price 3",
    BIDCOLLATERALPRICE4: "Bid Collateral Price 4",
    BIDCOLLATERALPRICE5: "Bid Collateral Price 5",
    BIDCOLLATERALPRICE6: "Bid Collateral Price 6",
    BIDCOLLATERALPRICE7: "Bid Collateral Price 7",
    BIDCOLLATERALPRICE8: "Bid Collateral Price 8",
    BIDCOLLATERALPRICE9: "Bid Collateral Price 9",
    ASKCOLLATERALPRICE0: "Ask Collateral Price 0",
    ASKCOLLATERALPRICE1: "Ask Collateral Price 1",
    ASKCOLLATERALPRICE2: "Ask Collateral Price 2",
    ASKCOLLATERALPRICE3: "Ask Collateral Price 3",
    ASKCOLLATERALPRICE4: "Ask Collateral Price 4",
    ASKCOLLATERALPRICE5: "Ask Collateral Price 5",
    ASKCOLLATERALPRICE6: "Ask Collateral Price 6",
    ASKCOLLATERALPRICE7: "Ask Collateral Price 7",
    ASKCOLLATERALPRICE8: "Ask Collateral Price 8",
    ASKCOLLATERALPRICE9: "Ask Collateral Price 9",
    COLLATERALPRICE: "Collateral Price",
    TOPBIDTRADEBROKER: "Top Bid Trade Broker",
    TOPASKTRADEBROKER: "Top Ask Trade Broker",
    TOPTOTALTRADEBROKER: "Top Total Trade Broker",
    DAILYRATECHANGE: "Daily Rate Change",
    PIVOT: "Pivot",
    SUPPORT1: "Support 1",
    SUPPORT2: "Support 2",
    RESISTANCE1: "Resistance 1",
    RESISTANCE2: "Resistance 2",
    EQUILIBRIUMTURNOVER: "Equilibrium Turnover",
    OPENCOMPOUNDRATE: "Open Compound Rate",
    HIGHCOMPOUNDRATE: "High Compound Rate",
    LOWCOMPOUNDRATE: "Low Compound Rate",
    SEQUENCEID: "Sequence Id",
    MBOTIME: "MBO Time",
    MBOUPDATECODE: "MBO Update Code",
    PUBLICLEASECERTPERCENTAGE: "Public Lease Cert Percentage",
    PRIVATELEASECERTPERCENTAGE: "PrivateLease Cert Percentage",
    PRECIOUSMETALSPERCENTAGE: "Precious Metals Percentage",
    BANKBONDSPERCENTAGE: "Bank Bonds Percentage",
    FOREIGNBILLSOFEXCPERCENTAGE: "Foreign Bills Of ExcPercentage",
    FOREIGNDEPTHSOFEXCPERCENTAGE: "Foreign Depths Of ExcPercentage",
    EUROBONDSPERCENTAGE: "Eurobonds Percentage",
    COMMERCIALPAPERSPERCENTAGE: "Commercial Papers Percentage",
    FUNDCERTPERCENTAGE: "Fund Cert Percentage",
    REALESTATECERTPERCENTAGE: "Real Estate Cert Percentage",
    PARTICIPATIONACCPERCENTAGE: "Participation Acc Percentage",
    DERIVATIVESPERCENTAGE: "Derivatives Percentage",
    ASSETBACKEDSECPERCENTAGE: "Asset Backed Sec Percentage",
    TERMDEPOSITPERCENTAGE: "Term Deposit Percentage",
    FOREIGNDEBTSPERCENTAGE: "Foreign Debts Percentage",
    FOREIGNEQUITYPERCENTAGE: "Foreign Equity Percentage",
    REPOPERCENTAGE: "Repo Percentage",
    CROSSTRADE: "Cross Trade",
    TRADABLESTATUS: "Tradable Status",
    SENSITIVITY: "Sensitivity",
    AUCTIONPRICE: "P. Open",
    AUCTIONVOLUME: "P. Open Volume",
    FINALEVALUATION: "Final Evaluation",
    GRAPHIC: "Graphic",
    FGOLDD: "Gold D",
    FGOLD60M: "Gold D 60M",
    FGOLD15M: "Gold D 15M",
    FGOLD5M: "Gold D 5M",
    LEGACYCODE: "Legacy Code",
    RANKEDBIDPRICE0: "Ranked Bid Price 0",
    RANKEDBIDPRICE1: "Ranked Bid Price 1",
    RANKEDBIDPRICE2: "Ranked Bid Price 2",
    RANKEDBIDPRICE3: "Ranked Bid Price 3",
    RANKEDBIDPRICE4: "Ranked Bid Price 4",
    RANKEDBIDPRICE5: "Ranked Bid Price 5",
    RANKEDBIDPRICE6: "Ranked Bid Price 6",
    RANKEDBIDPRICE7: "Ranked Bid Price 7",
    RANKEDBIDPRICE8: "Ranked Bid Price 8",
    RANKEDBIDPRICE9: "Ranked Bid Price 9",
    RANKEDBIDAMOUNT0: "Ranked Bid Volume 0",
    RANKEDBIDAMOUNT1: "Ranked Bid Volume 1",
    RANKEDBIDAMOUNT2: "Ranked Bid Volume 2",
    RANKEDBIDAMOUNT3: "Ranked Bid Volume 3",
    RANKEDBIDAMOUNT4: "Ranked Bid Volume 4",
    RANKEDBIDAMOUNT5: "Ranked Bid Volume 5",
    RANKEDBIDAMOUNT6: "Ranked Bid Volume 6",
    RANKEDBIDAMOUNT7: "Ranked Bid Volume 7",
    RANKEDBIDAMOUNT8: "Ranked Bid Volume 8",
    RANKEDBIDAMOUNT9: "Ranked Bid Volume 9",
    RANKEDBIDORDERKEY0: "Ranked Bid Order Key 0",
    RANKEDBIDORDERKEY1: "Ranked Bid Order Key 1",
    RANKEDBIDORDERKEY2: "Ranked Bid Order Key 2",
    RANKEDBIDORDERKEY3: "Ranked Bid Order Key 3",
    RANKEDBIDORDERKEY4: "Ranked Bid Order Key 4",
    RANKEDBIDORDERKEY5: "Ranked Bid Order Key 5",
    RANKEDBIDORDERKEY6: "Ranked Bid Order Key 6",
    RANKEDBIDORDERKEY7: "Ranked Bid Order Key 7",
    RANKEDBIDORDERKEY8: "Ranked Bid Order Key 8",
    RANKEDBIDORDERKEY9: "Ranked Bid Order Key 9",
    RANKEDASKPRICE0: "Ranked Ask Price 0",
    RANKEDASKPRICE1: "Ranked Ask Price 1",
    RANKEDASKPRICE2: "Ranked Ask Price 2",
    RANKEDASKPRICE3: "Ranked Ask Price 3",
    RANKEDASKPRICE4: "Ranked Ask Price 4",
    RANKEDASKPRICE5: "Ranked Ask Price 5",
    RANKEDASKPRICE6: "Ranked Ask Price 6",
    RANKEDASKPRICE7: "Ranked Ask Price 7",
    RANKEDASKPRICE8: "Ranked Ask Price 8",
    RANKEDASKPRICE9: "Ranked Ask Price 9",
    RANKEDASKAMOUNT0: "Ranked Ask Volume 0",
    RANKEDASKAMOUNT1: "Ranked Ask Volume 1",
    RANKEDASKAMOUNT2: "Ranked Ask Volume 2",
    RANKEDASKAMOUNT3: "Ranked Ask Volume 3",
    RANKEDASKAMOUNT4: "Ranked Ask Volume 4",
    RANKEDASKAMOUNT5: "Ranked Ask Volume 5",
    RANKEDASKAMOUNT6: "Ranked Ask Volume 6",
    RANKEDASKAMOUNT7: "Ranked Ask Volume 7",
    RANKEDASKAMOUNT8: "Ranked Ask Volume 8",
    RANKEDASKAMOUNT9: "Ranked Ask Volume 9",
    RANKEDASKORDERKEY0: "Ranked Ask Order Key 0",
    RANKEDASKORDERKEY1: "Ranked Ask Order Key 1",
    RANKEDASKORDERKEY2: "Ranked Ask Order Key 2",
    RANKEDASKORDERKEY3: "Ranked Ask Order Key 3",
    RANKEDASKORDERKEY4: "Ranked Ask Order Key 4",
    RANKEDASKORDERKEY5: "Ranked Ask Order Key 5",
    RANKEDASKORDERKEY6: "Ranked Ask Order Key 6",
    RANKEDASKORDERKEY7: "Ranked Ask Order Key 7",
    RANKEDASKORDERKEY8: "Ranked Ask Order Key 8",
    RANKEDASKORDERKEY9: "Ranked Ask Order Key 9",
    MMQUOTEUPDATECODE: "MM Quote Update Code",
    CLEARINGTRADEINFO: "Clearing Trade Info",
    LIVESTATUS: "Live Status",
    TOPFIVEBROKERBIDTRADEVOLUME5M: "Top Five Broker Bid Trade Volume 5M",
    TOPFIVEBROKERASKTRADEVOLUME5M: "Top Five Broker Ask Trade Volume 5M",
    TOPFIVEBROKERNETTRADEVOLUME5M: "Top Five Broker Net Trade Volume 5M",
    TOPFIVEBROKERBIDTRADETURNOVER5M: "Top Five Broker Bid Trade Turnover 5M",
    TOPFIVEBROKERASKTRADETURNOVER5M: "Top Five Broker Ask Trade Turnover 5M",
    TOPFIVEBROKERNETTRADETURNOVER5M: "Top Five Broker Net Trade Turnover 5M",
    TOPFIVEBROKERBIDTRADEVOLUME10M: "Top Five Broker Bid Trade Volume 10M",
    TOPFIVEBROKERASKTRADEVOLUME10M: "Top Five Broker Ask Trade Volume 10M",
    TOPFIVEBROKERNETTRADEVOLUME10M: "Top Five Broker Net Trade Volume 10M",
    TOPFIVEBROKERBIDTRADETURNOVER10M: "Top Five Broker Bid Trade Turnover 10M",
    TOPFIVEBROKERASKTRADETURNOVER10M: "Top Five Broker Ask Trade Turnover 10M",
    TOPFIVEBROKERNETTRADETURNOVER10M: "Top Five Broker Net Trade Turnover 10M",
    CAPITALRATIO: "Capital Ratio",
    SHORTDEBTONTOTALASSETS: "Short Debt On Total Assets",
    SHORTDEBTONTOTALDEBT: "Short Debt On Total Debt",
    RETURNONEQUITY: "Return On Equity",
    SESSIONHIGH: "Session High",
    SESSIONLOW: "Session Low",
    SESSIONOPEN: "Session Open",
    SESSIONCHANGE: "Session Change",
    SESSIONCHANGEPERCENT: "Session Change Percent",
    SESSIONTOTALVOLUME: "Session Total Volume",
    SESSIONTOTALTURNOVER: "Session Total Turnover",
    SESSIONTOTALTURNOVERCURRENCY: "Session Total Turnover Currency",
    SESSIONVWAP: "Session VWAP",
    SESSIONCONTRACTS: "Session Contracts",
    BESTBID: "Best Bid",
    BESTASK: "Best Ask",
    BIDTRADECOUNT: "Bid Trade Count",
    ASKTRADECOUNT: "Ask Trade Count",
    UPTICKCOUNT: "Up Tick Count",
    UPTICKVOLUME: "Up Tick Volume",
    UPTICKTURNOVER: "Up Tick Turnover",
    DOWNTICKCOUNT: "Down Tick Count",
    DOWNTICKVOLUME: "Down Tick Volume",
    DOWNTICKTURNOVER: "Down Tick Turnover",
    SMA8: "SMA 8",
    EMA8: "EMA 8",
    PUBLICDOMESTICDEBTPERCENTAGE: "Public Domestic Debt Percentage",
    PUBLICLEASEFCPERCENTAGE: "Public Lease FC Percentage",
    REALESTATEINVESTMENTFUNDSPERCENTAGE: "Real Estate Investment Funds Percentage",
    PUBLICFOREIGNLEASEPERCENTAGE: "Public Foreign Lease Percentage",
    DEPOSITFCPERCENTAGE: "Deposit FC Percentage",
    PARTICIPATIONACCOUNTFCPERCENTAGE: "Participation Account FC Percentage",
    DEPOSITTLPERCENTAGE: "Deposit TL Percentage",
    PSFOREIGNLEASEPERCENTAGE: "PS Foreign Lease Percentage",
    FOREIGNPUBLICDEBTPERCENTAGE: "Foreign Public Debt Percentage",
    PRIVATEEXTERNALBORROWINGPERCENTAGE: "Private External Borrowing Percentage",
    TRADEDFUNDSPARTICIPATIONPERCENTAGE: "Traded Funds Participation Percentage",
    PUBLICDEBTPRECIOUSMETALSPERCENTAGE: "Public Debt Precious Metals Percentage",
    FOREIGNTRADEDFUNDSPERCENTAGE: "Foreign Traded Funds Percentage",
    PARTICIPATIONACCOUNTAUPERCENTAGE: "Participation Account AU Percentage",
    FOREIGNPRIVATESECTORDEBTPERCENTAGE: "Foreign Private Sector Debt Percentage",
    MUTUALFUNDSPARTICIPATIONPERCENTAGE: "Mutual Funds Participation Percentage",
    DEPOSITAUPERCENTAGE: "Deposit AU Percentage",
    PARTICIPATIONACCOUNTTLPERCENTAGE: "Participation Account TL Percentage",
    FUTURESCASHCOLLATERALSPERCENTAGE: "Futures Cash Collaterals Percentage",
    PRECIOUSMETALSETFPERCENTAGE: "Precious Metals ETF Percentage",
    PRIVATEEQUITYINVESTMENTFUNDSPERCENTAGE: "Private Equity Investment Funds Percentage",
    PUBLICLEASETLPERCENTAGE: "Public Lease TL Percentage",
    PUBLICLEASEPRECIOUSMETALSPERCENTAGE: "Public Lease Precious Metals Percentage",
    BIDPRICE10: "Bid Price 10",
    BIDQTY20: "Bid Qty 20",
    BIDQTY24: "Bid Qty 24",
    ASKPRICE13: "Ask Price 13",
    ASKPRICE17: "Ask Price 17",
    BIDQTY11: "Bid Qty 11",
    BIDQTY15: "Bid Qty 15",
    ASKPRICE10: "Ask Price 10",
    ASKPRICE14: "Ask Price 14",
    ASKAMOUNT10: "Ask Volume 10",
    BIDPRICE13: "Bid Price 13",
    ASKPRICE21: "Ask Price 21",
    BIDPRICE21: "Bid Price 21",
    BIDAMOUNT15: "Bid Volume 15",
    BIDAMOUNT16: "Bid Volume 16",
    ASKPRICE23: "Ask Price 23",
    ASKAMOUNT12: "Ask Volume 12",
    ASKAMOUNT13: "Ask Volume 13",
    ASKAMOUNT18: "Ask Volume 18",
    ASKQTY17: "Ask Qty 17",
    ASKQTY23: "Ask Qty 23",
    BIDPRICE12: "Bid Price 12",
    BIDQTY22: "Bid Qty 22",
    BIDAMOUNT18: "Bid Volume 18",
    BIDQTY23: "Bid Qty 23",
    ASKQTY21: "Ask Qty 21",
    ASKPRICE20: "Ask Price 20",
    ASKAMOUNT20: "Ask Volume 20",
    BIDPRICE18: "Bid Price 18",
    BIDPRICE11: "Bid Price 11",
    BIDPRICE19: "Bid Price 19",
    ASKPRICE12: "Ask Price 12",
    ASKPRICE15: "Ask Price 15",
    ASKAMOUNT24: "Ask Volume 24",
    ASKQTY11: "Ask Qty 11",
    ASKQTY19: "Ask Qty 19",
    BIDAMOUNT10: "Bid Volume 10",
    BIDQTY10: "Bid Qty 10",
    ASKAMOUNT16: "Ask Volume 16",
    ASKAMOUNT22: "Ask Volume 22",
    ASKQTY18: "Ask Qty 18",
    BIDAMOUNT19: "Bid Volume 19",
    BIDPRICE20: "Bid Price 20",
    BIDAMOUNT21: "Bid Volume 21",
    BIDQTY14: "Bid Qty 14",
    ASKPRICE16: "Ask Price 16",
    ASKQTY13: "Ask Qty 13",
    ASKQTY16: "Ask Qty 16",
    BIDAMOUNT14: "Bid Volume 14",
    BIDQTY19: "Bid Qty 19",
    BIDQTY21: "Bid Qty 21",
    ASKAMOUNT11: "Ask Volume 11",
    ASKAMOUNT17: "Ask Volume 17",
    ASKQTY14: "Ask Qty 14",
    BIDAMOUNT13: "Bid Volume 13",
    BIDPRICE24: "Bid Price 24",
    BIDQTY18: "Bid Qty 18",
    ASKPRICE22: "Ask Price 22",
    ASKQTY20: "Ask Qty 20",
    BIDAMOUNT11: "Bid Volume 11",
    BIDAMOUNT12: "Bid Volume 12",
    BIDAMOUNT22: "Bid Volume 22",
    BIDQTY13: "Bid Qty 13",
    BIDQTY16: "Bid Qty 16",
    ASKAMOUNT14: "Ask Volume 14",
    ASKAMOUNT23: "Ask Volume 23",
    ASKQTY10: "Ask Qty 10",
    ASKQTY22: "Ask Qty 22",
    BIDPRICE16: "Bid Price 16",
    BIDPRICE17: "Bid Price 17",
    BIDPRICE22: "Bid Price 22",
    BIDPRICE23: "Bid Price 23",
    ASKAMOUNT19: "Ask Volume 19",
    ASKQTY12: "Ask Qty 12",
    BIDPRICE14: "Bid Price 14",
    BIDPRICE15: "Bid Price 15",
    BIDQTY17: "Bid Qty 17",
    ASKPRICE11: "Ask Price 11",
    ASKPRICE24: "Ask Price 24",
    ASKAMOUNT15: "Ask Volume 15",
    BIDAMOUNT24: "Bid Volume 24",
    ASKPRICE18: "Ask Price 18",
    ASKPRICE19: "Ask Price 19",
    BIDAMOUNT17: "Bid Volume 17",
    BIDAMOUNT20: "Bid Volume 20",
    BIDAMOUNT23: "Bid Volume 23",
    BIDQTY12: "Bid Qty 12",
    ASKAMOUNT21: "Ask Volume 21",
    ASKQTY15: "Ask Qty 15",
    ASKQTY24: "Ask Qty 24",
    NEWSSOURCEREF: "News Source Ref",
    SPLITRATIO: "Split Ratio",
    LASTINCURRENCY: "Last In Currency",
    TOTALTRADECOUNT: "Total Trade Count",
    NEWSBEHALFFUNDTITLE: "News Behalf Fund Title",
    NEWSBEHALFFUNDID: "News Behalf Fund Id",
    SPLITRATIODATE: "Split Ratio Date",
    REALESTATEINVESTMENTS: "Real Estate Investments",
    VENTURECAPITALINVESTMENTS: "Venture Capital Investments",
    FGOLD240M: "F Gold 240M",
    INTRAYEARCLOSE: "Ενδοετήσιο Κλείσιμο",
    INTRAYEARCHANGE: "Ενδοετήσια Μεταβολή",
    INTRAYEARCHANGEPERCENT: "Ενδοετήσια Μεταβολή %",
    INTRAWEEKCLOSE: "Ενδοεβδομαδιαίο Κλείσιμο",
    INTRAWEEKCHANGE: "Ενδοεβδομαδιαία Μεταβολή",
    INTRAWEEKCHANGEPERCENT: "Ενδοεβδομαδιαία Μεταβολή %",
    INTRAMONTHCLOSE: "Ενδομηνιαίο Κλείσιμο",
    INTRAMONTHCHANGE: "Ενδομηνιαία Μεταβολή",
    INTRAMONTHCHANGEPERCENT: "Ενδομηνιαία Μεταβολή %",
    INSTITUTIONALINVESTORSTOCKSIZE: "Θεσμικοί Επενδυτές Μετοχές",
    INSTITUTIONALINVESTORRATIO: "Ποσοστό Θεσμικών Επενδυτών",
    INDIVIDUALINVESTORSTOCKSIZE: "Ιδιώτες Επενδυτές Μετοχές",
    INDIVIDUALINVESTORRATIO: "Ποσοστό Ιδιωτών Επενδυτών",
    FOREIGNSETTLEMENTRATIO: "Ποσοστό Ξένου Διακανονισμού",
    FIRSTBROKERBIDTOTALVOLUME: "1ος Χρηματιστής Αγορά Συνολικός Όγκος",
    FIRSTBROKERBIDTOTALTURNOVER: "1ος Χρηματιστής Αγορά Συνολικός Τζίρος",
    FIRSTBROKERASKTOTALVOLUME: "1ος Χρηματιστής Πώληση Συνολικός Όγκος",
    FIRSTBROKERASKTOTALTURNOVER: "1ος Χρηματιστής Πώληση Συνολικός Τζίρος",
    SECONDBROKERBIDTOTALVOLUME: "2ος Χρηματιστής Αγορά Συνολικός Όγκος",
    SECONDBROKERBIDTOTALTURNOVER: "2ος Χρηματιστής Αγορά Συνολικός Τζίρος",
    SECONDBROKERASKTOTALVOLUME: "2ος Χρηματιστής Πώληση Συνολικός Όγκος",
    SECONDBROKERASKTOTALTURNOVER: "2ος Χρηματιστής Πώληση Συνολικός Τζίρος",
    SECONDBIDTRADEBROKER: "2ος Χρηματιστής Αγοράς",
    SECONDASKTRADEBROKER: "2ος Χρηματιστής Πώλησης",
    BIDCOLLATERALPRICE: "Τιμή Εγγύησης Αγοράς",
    ASKCOLLATERALPRICE: "Τιμή Εγγύησης Πώλησης",
    PSR: "PSR",
    LEVERAGERATIO: "Δείκτης Μόχλευσης",
    INVESTORCOUNT: "Αριθμός Επενδυτών"
  }

};
